import type { TabItem } from "shared/ui";

export type RaffleTab = "raffles" | "history" | "create";

const BASE_TABS: TabItem<RaffleTab>[] = [
  { value: "raffles", label: "Promos" },
  { value: "history", label: "History" },
];

// Создание доступно только с правом promo_actions_wheel.
export const getRaffleTabs = (canCreate: boolean): TabItem<RaffleTab>[] =>
  canCreate ? [...BASE_TABS, { value: "create", label: "Create" }] : BASE_TABS;
